import Swal from 'sweetalert2';
import { GenerarCodigoGenerico_, ValidarCodigoGenerico_ } from '../services/WebAPI_Utrahuilca';

const mostrarModalOTP = ({ idCodOtp, codMotOtp, idIntento, descripcion, onReenviar }) => {
    return Swal.fire({
        icon: 'info',
        title: 'Ingresa el código de verificación',
        html: `<span style="text-align: justify">${descripcion || ''}</span>
               <input type="text" id="codigo_otp" class="swal2-input" maxlength="4"
                      placeholder="Ingrese el código" inputmode="numeric"
                      pattern="[0-9]*" autocomplete="one-time-code">`,
        showCancelButton: true,
        showCloseButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'Validar',
        cancelButtonText: 'Reenviar Código',
        cancelButtonColor: '#008694',
        showLoaderOnConfirm: true,
        inputAttributes: { autocapitalize: 'off' },
        preConfirm: async () => {
            const codigoIngresado = Swal.getPopup().querySelector('#codigo_otp').value;

            if (!codigoIngresado) {
                Swal.showValidationMessage('Ingresa el código recibido');
                return false;
            }

            try {
                const respuesta = await ValidarCodigoGenerico_({
                    idcodotp: idCodOtp,
                    codmototp: codMotOtp,
                    codigootp: parseInt(codigoIngresado, 10),
                    idintento: idIntento,
                });
                const { codresp, desresp } = respuesta[0];

                if (codresp === '000000') {
                    return true;
                }
                Swal.showValidationMessage(desresp || 'Código incorrecto, intenta nuevamente');
                return false;
            } catch (error) {
                Swal.showValidationMessage('Ocurrió un error al validar el código');
                return false;
            }
        },
    }).then(async (result) => {
        if (result.isConfirmed) {
            return true;
        }
        if (result.dismiss === Swal.DismissReason.cancel && onReenviar) {
            return onReenviar();
        }
        return false;
    });
};

export const validarOTPGenerico = async ({
    idTipoDoc,
    tipoIden,
    nit,
    numeroCelular,
    tipPer,
    correo,
    nomCom,
    codMotOtp,
    idProceso,
    idMedioNotificacion,
}) => {
    if (!idTipoDoc || idTipoDoc === 0 || !nit || !numeroCelular) {
        Swal.fire({
            icon: 'warning',
            title: 'Advertencia',
            text: 'Datos de entrada en formato incorrecto.',
        });
        return false;
    }

    try {
        const peticion = await GenerarCodigoGenerico_({
            idtipodoc: idTipoDoc,
            tipoiden: tipoIden,
            nit,
            numerocelular: numeroCelular,
            tipper: tipPer,
            correo,
            nomcom: nomCom,
            codmototp: codMotOtp,
            idproceso: idProceso,
            idmedionotificacion: idMedioNotificacion,
        });

        if (!peticion || peticion.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                text: 'Ocurrió un error!',
            });
            return false;
        }

        const { codresp, codigo, idintento, desresp } = peticion[0];

        if (codresp !== '000000') {
            const mensaje =
                desresp ||
                `Comunícate con nuestro centro de contacto. <a target="_blank" rel="noopener noreferrer" href="https://api.whatsapp.com/send?phone=573102100828">Aquí.</a>`;
            Swal.fire({ icon: 'warning', title: 'Advertencia', text: mensaje });
            return false;
        }

        return await mostrarModalOTP({
            idCodOtp: parseInt(codigo, 10),
            codMotOtp,
            idIntento: parseInt(idintento, 10),
            descripcion: desresp,
            onReenviar: () =>
                validarOTPGenerico({
                    idTipoDoc,
                    tipoIden,
                    nit,
                    numeroCelular,
                    tipPer,
                    correo,
                    nomCom,
                    codMotOtp,
                    idProceso,
                    idMedioNotificacion,
                }),
        });
    } catch (error) {
        Swal.fire({ icon: 'error', text: 'Ocurrió un error!' });
        return false;
    }
};